import { EventsService } from './../../../../shared/services/events/events.service';
import { Router } from '@angular/router';
import { VariablesService } from './../../../../shared/services/variables/variables.service';
import { UtilService } from './../../../../shared/services/util/util.service';
import { Component, Input, OnInit } from '@angular/core';
import { CookieService, VwoService } from '../../../../shared/services';

@Component({
  selector: 'app-download-app-banner',
  templateUrl: './download-app-banner.component.html',
  styleUrls: ['./download-app-banner.component.scss']
})
export class DownloadAppBannerComponent implements OnInit {

  @Input() config;
  isMobile;
  isIos;

  constructor(
    public utilService: UtilService,
    public vars: VariablesService,
    private router: Router,
    private eventsService: EventsService,
    private cookieService: CookieService,
    public vwo: VwoService
  ) { }
  sipListData = [
    { id: 1, title: 'Manage contributions on-the-go', iconName: 'Phone' },
    { id: 2, title: 'Personalized contributor dashboard', iconName: 'Activity' },
    { id: 3, title: 'Faster contribution updates', iconName: 'Notification' },
    { id: 4, title: 'Discover and share', iconName: 'Refer' }
  ];
  mcdListData = [
    { id: 1, title: 'Access a personalized dashboard', iconName: 'phone' },
    { id: 2, title: 'Withdraw your funds faster', iconName: 'withdraw' },
    { id: 3, title: 'Keep track of all your contributions received', iconName: 'piggy-bank' },
    { id: 4, title: 'Start fundraisers within seconds', iconName: 'support' }
  ];
  kettoDescList = [
    { id: 1, title: 'Faster contribution updates', iconName: '' },
    { id: 2, title: 'Manage contributions on-the-go', iconName: '' },
    { id: 3, title: 'Personalized contributor dashboard', iconName: '' },
    { id: 4, title: 'Exclusive Rewards', iconName: '' }
  ];
  isSipSubscribed = false;
  lastUrlName;
  isLoaded = false;
  selectedListData = [];
  downloadLink = '';
  isAppUser;
  userData;

  ngOnInit() {
    this.isMobile = this.utilService.isMobile();
    this.isIos = this.utilService.isIOSDevice();
    this.selectedListData = this.mcdListData;
    this.vars.userData.subscribe({
      next: (res) => {
        this.userData = res;
        this.isSipSubscribed = [1, 2].includes(res?.listsubscriptions?.medical?.status_flag);
        this.isLoaded = true;
        if (this.isSipSubscribed) {
          this.selectedListData = this.sipListData;
        } else {
          this.selectedListData = this.mcdListData;
        }
      }
    });
    const urlWithoutParams = this.router.url.split('?')[0];
    this.lastUrlName = urlWithoutParams.split('/')[urlWithoutParams.split('/').length - 1];

    this.isAppUser = this.cookieService.getCookie('platform');
  }

  systemEvents(for_device) {
    const payload: any = {
      eventName: 'download_app_banner',
      page_name: this.vars.pageName,
      info_1: this.config?.info_1 || '',
      info_2: for_device,
      info_3: this.isSipSubscribed ? 'existing_sip_user' : ''
    };
    this.eventsService.sendSystemEvent(payload).subscribe(_ => _);
    if (this.isAppUser) {
      this.utilService.nativeNavigation('https://sipketto.page.link/4Mnz');
    }
  }

  downloadAppRedirect(type) {
    const a = document.createElement('a');
    a.target = '_blank';
    a.href = this.getMcdDownloadLink(type);
    a.click();
    this.systemEvents(this.isIos ? 'iOS' : 'android');
  }

  getMcdDownloadLink(type): string {
    if (type === 'mcd') {
      return this.isIos ? this.vars.appLink.iOS_mcd : this.vars.appLink.android_mcd;
    } else {
      if (this.vars.pageName?.match('home|stories|campaign|thank_you')) {
        return this.vars.appLink.app_flyer;
      } else {
        return this.isIos ? this.vars.appLink.iOS : this.vars.appLink.android;
      }
    }
  }

  redirect() {
    this.utilService.redirectWithUTM('new/anniversary', { utm_term: 'home', utm_content: 'top_banner', enable_sip: 1 });
  }
}
